import { render } from "./PaychanguMobileWebsite.vue?vue&type=template&id=a99f464a&scoped=true"
import script from "./PaychanguMobileWebsite.vue?vue&type=script&lang=js"
export * from "./PaychanguMobileWebsite.vue?vue&type=script&lang=js"

import "./PaychanguMobileWebsite.vue?vue&type=style&index=0&id=a99f464a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99f464a"]])

export default __exports__